/**
 * @copyright 2025 Glimbr Pty Ltd
 * @version 2026-04-20-v3
 */
import { createBrowserRouter } from 'react-router-dom';
import { Shell } from './layout/shell';
import { OverviewPage } from './pages/overview';
import { UsersPage } from './pages/users/index';
import { SupportPage } from './pages/support';
import { SystemHealthPage } from './pages/system-health';
import { ErrorLogsPage } from './pages/error-logs';
import { BillingPage } from './pages/billing';
import { AffiliateManagerPage } from './pages/affiliate-manager';
import { AnalyticsPage } from './pages/analytics';
import { TaxonomyPage } from './pages/taxonomy';
import { HelpDocsPage } from './pages/help-docs';
import { StoragePage } from './pages/storage';
import { NotificationsPage } from './pages/notifications';
import { EmailTemplatesPage } from './pages/email-templates';
import { RestorePage } from './pages/restore';
import { AdminAuditPage } from './pages/admin-audit';
import { CompliancePage } from './pages/compliance';
import { PlaceholderPage } from './pages/placeholder';

export const router = createBrowserRouter([
    {
        path: '/',
        element: <Shell />,
        children: [
            { index: true, element: <OverviewPage /> },
            { path: 'users', element: <UsersPage /> },
            { path: 'support', element: <SupportPage /> },
            { path: 'system-health', element: <SystemHealthPage /> },
            { path: 'error-logs', element: <ErrorLogsPage /> },
            { path: 'billing', element: <BillingPage /> },
            { path: 'affiliate-manager', element: <AffiliateManagerPage /> },
            { path: 'analytics', element: <AnalyticsPage /> },
            { path: 'taxonomy', element: <TaxonomyPage /> },
            { path: 'help-docs', element: <HelpDocsPage /> },
            { path: 'storage', element: <StoragePage /> },
            { path: 'notifications', element: <NotificationsPage /> },
            { path: 'email-templates', element: <EmailTemplatesPage /> },
            { path: 'restore', element: <RestorePage /> },
            { path: 'privacy-terms', element: <CompliancePage /> },
            { path: 'admin-audit', element: <AdminAuditPage /> },
            { path: '*', element: <PlaceholderPage /> }
        ]
    }
]);
